import ThemeSchema from './schema';
import colors from './colors';
import { fontSize } from './constants';

const cpLightTheme: ThemeSchema = {
  accordion: {
    text: colors.gray_90,
    caret: colors.gray_40,
    border: colors.gray_20,
    icon: colors.gray_40,
  },
  font: {
    fontFamily: '"Roboto", sans-serif',
    fontLinks: [
      {
        rel: 'preconnect',
        href: 'https://fonts.googleapis.com',
        crossorigin: false,
      },
      {
        rel: 'preconnect',
        href: 'https://fonts.gstatic.com',
        crossorigin: true,
      },
      {
        rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500&display=swap',
        crossorigin: false,
      },
    ],
  },
  headingFont: {
    fontFamily: '"Roboto", sans-serif',
    fontSize,
  },
  form: {
    label: colors.gray_50,
    fieldset: {
      bg: colors.gray_05,
      border: colors.gray_20,
      text: colors.gray_70,
    },
  },
  page: {
    header: {
      bg: colors.gray_10,
      border: colors.blue_30,
      text: colors.gray_70,
    },
    headerLogo: {
      bg: colors.white,
    },
    body: {
      bg: colors.white,
      headerText: colors.gray_90,
      text: colors.gray_70,
    },
    footer: {
      bg: colors.gray_10,
      border: colors.gray_30,
    },
  },
  card: {
    header: {
      bg: colors.blue_10,
      text: colors.gray_70,
      border: colors.blue_30,
    },
    body: {
      bg: colors.white,
      text: colors.gray_70,
      headerText: colors.gray_50,
    },
  },
  timeline: {
    icon: colors.gray_90,
    line: colors.gray_20,
    description: colors.gray_90,
    time: colors.gray_90,
  },
  displayNumber: {
    title: colors.gray_50,
    value: colors.gray_70,
    unit: colors.gray_70,
  },
  select: {
    bottomBorder: colors.gray_10,
    selectedOptionText: colors.gray_70,
    unselectedOptionText: colors.gray_70,
    focusedOptionBackground: colors.gray_10,
    text: colors.gray_90,
    icons: colors.gray_40,
    background: colors.white,
  },
  button: {
    primary: {
      normal: {
        bg: colors.orange_50,
        text: colors.gray_90,
      },
      disabled: {
        bg: colors.gray_20,
        text: colors.gray_50,
      },
      hover: {
        bg: colors.orange_55,
      },
    },
    secondary: {
      normal: {
        bg: colors.white,
        border: colors.orange_50,
        text: colors.gray_90,
      },
      disabled: {
        border: colors.gray_30,
        text: colors.gray_50,
      },
      hover: {
        bg: colors.white,
      },
    },
    circle: {
      normal: {
        bg: colors.white,
        text: colors.gray_70,
      },
      hover: {
        bg: colors.gray_20,
      },
      disabled: {
        bg: colors.gray_30,
      },
    },
    link: {
      normal: {
        text: colors.blue_55,
      },
      hover: {
        bg: colors.gray_20,
      },
    },
    danger: {
      normal: {
        bg: colors.transparent,
        text: colors.red_50,
      },
    },
  },
  link: {
    text: colors.blue_55,
    hover: colors.gray_20,
    disabled: colors.gray_50,
    active: colors.blue_30,
    focus: colors.gray_90,
  },
  icon: colors.gray_40,
  focus: colors.blue_55,
  label: colors.gray_50,
  error: colors.red_50,
  input: {
    normal: {
      text: colors.gray_70,
      bottomBorder: colors.gray_10,
    },
    focus: {
      text: colors.gray_90,
      bg: colors.gray_10,
    },
    disabled: {
      text: colors.gray_50,
    },
    hover: {
      text: colors.gray_90,
    },
  },
  checkbox: {
    label: colors.gray_90,
    color: colors.orange_55,
  },
  spinner: {
    color: colors.orange_55,
  },
  tabs: {
    text: colors.gray_70,
    selectedText: colors.blue_gray_70,
    bottomBorder: colors.gray_10,
  },
  shadow: {
    default: `${colors.dark_charcoal}59`,
    hover: `${colors.dark_charcoal}87`,
  },
  modal: {
    separator: colors.gray_20,
  },
  info: {
    headerText: colors.gray_90,
    text: colors.gray_90,
    date: colors.gray_70,
    border: colors.gray_20,
    icon: colors.gray_40,
  },
  imagePlaceholder: {
    bg: colors.blue_gray_50,
    text: colors.gray_90,
  },
  datePicker: {
    bg: colors.white,
    border: colors.gray_10,
  },
};

export default cpLightTheme;
